define('models/appsT1Users',["jQuery", "T1", "T1Model"], function ($, T1, T1Model) {
  "use strict";

  T1.Models.AppsT1Users = T1Model.extend({
    url: "users/"
  });
  return T1.Models.AppsT1Users;
});
